export default class StoreEdit {
	constructor(node) {
		this.node = node;
		this.formUploadNode = this.node.querySelector('.store-edit__form_upload');
		this.formNode = this.node.querySelector('.store-edit__form');
		this.formTotemNode = this.node.querySelector('.store-edit__totem_customization_form'); 

		this.addCKEditor();
		this.addListeners();
	}

	static init() {
		let storeEditNode = document.querySelector("[data-store-edit]");

		if (storeEditNode) {
			return new StoreEdit(storeEditNode);
		}
	}

	addCKEditor() {
		this.CKEditor = CKEDITOR.inline(this.formNode.querySelector('.store-edit__form__description'), {
			toolbar: "light",
			toolbar_light: [
				{ name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
				{ name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'RemoveFormat'] },
				{ name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
				{ name: 'styles', items: ['Styles'] },
            ],
			stylesSet: [
				{ name: 'Small title', element: 'div', attributes: { 'class': 'tit extrasmall' } }
            ]
		});
	}

	addListeners() {
		var _this = this;

		this.node.querySelector('.store-edit__overlay').addEventListener('click', function() {
			_this.node.querySelector('.store-edit').classList.add('store-edit--hidden');
		});

		this.formNode.querySelector('input[type="submit"]').addEventListener('click', function(event) {
			event.preventDefault();
			_this.submitEditForm();
		});

		if (this.formTotemNode) {
			this.formTotemNode.querySelector('select[name="editing-totem-id"]').addEventListener('change', function(event) {
				event.preventDefault();
				_this.submitTotemForm();
			});	
		}

		this.formUploadNode.querySelector('.store-edit__form_upload__submit').addEventListener('click', function(event) {
			event.preventDefault();
			_this.uploadImage();
		});

		this.formUploadNode.querySelector('.store-edit__form_upload__crop').addEventListener('click', function(event) {
			event.preventDefault();
			_this.cropImage();
		});
	}

	cropImage() {
		let _this = this;
		let responseData = {};

		var cropperData = _this.cropper.getData(true);
		// console.log(cropperData);

		var submittedData = {
			storeID: _this.formUploadNode.querySelector('input[name="storeID"]').value,
			cropper_x: cropperData.x,
			cropper_y: cropperData.y,
			cropper_width: cropperData.width,
			cropper_height: cropperData.height
		};

		this.formUploadNode.classList.add('disabled');

		$.ajax({
			type: 'POST',
			url: "/WS/wsStoreEdit.asmx/StoreImageCrop",
			cache: false,
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(submittedData),
			dataType: 'json',
			success: function(data) {
				responseData = data;

				_this.cropper.destroy();

				_this.formUploadNode.querySelector('.store-edit__form__cover-img img').setAttribute('src', responseData.d.imageURL);
				_this.formUploadNode.querySelector('.store-edit__form__cover-img__crop-actions').classList.add('hidden');
			},
			complete: function() {
				// console.log(responseData);

				_this.formUploadNode.classList.remove('disabled');
			}
		});
	}

	uploadImage() {
		let _this = this;
		let responseData = {};
		let uploadButton = this.formUploadNode.querySelector('input[type="button"]');
		let selectedFile = this.formUploadNode.querySelector('input[type="file"]').files[0];

		this.formUploadNode.classList.add('disabled');
		uploadButton.classList.add('disabled');

		let fileReader = new FileReader();
		fileReader.readAsDataURL(selectedFile);
		fileReader.addEventListener("load", function() {
			let submittedData = {
				storeID: _this.formUploadNode.querySelector('input[name="storeID"]').value,
				filename: selectedFile.name,
				base64: fileReader.result
			};

			$.ajax({
				type: 'POST',
				url: _this.formUploadNode.getAttribute('action'),
				cache: false,
				contentType: "application/json; charset=utf-8",
				data: JSON.stringify(submittedData),
				dataType: 'json',
				success: function(data) {
					responseData = data;

					_this.formUploadNode.querySelector('.store-edit__form__cover-img img').setAttribute('src', responseData.d.imageURL);
					_this.formUploadNode.querySelector('.store-edit__form__cover-img__crop-actions').classList.remove('hidden');

					_this.cropper = new Cropper(_this.formUploadNode.querySelector('.store-edit__form__cover-img img'), {
						aspectRatio: 16 / 10
					});
				},
				complete: function() {
					// console.log(responseData);

					_this.formUploadNode.classList.remove('disabled');
					uploadButton.classList.remove('disabled');
				}
			});
		}, false);
	}

	submitTotemForm() {
		let _this = this;

		_this.formTotemNode.querySelector('.store-edit__totem_customization_form-message').innerHTML = '';
		this.formTotemNode.classList.add('busy');

		$.ajax({
			type: "POST",
			url: this.formTotemNode.getAttribute('action'),
			cache: false,
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify({totemId: this.formTotemNode.querySelector('select[name="editing-totem-id"]').value}),
			dataType: "json",
			success: function(data) {
				window.location.reload();
			},
			error: function(data) {
				_this.formTotemNode.querySelector('.store-edit__totem_customization_form-message').innerHTML = 'error on totem selection';
			}
		});
	}

	submitEditForm() {
		var _this = this;
		var responseData = {};
		let submitButton = this.formNode.querySelector('input[type="submit"]');

		submitButton.classList.add('disabled');

		let submittedData = {
			storeID: this.formNode.querySelector('input[name="storeID"]').value,
			description: this.CKEditor.getData()
		};

		$.ajax({
			type: "POST",
			url: this.formNode.getAttribute('action'),
			cache: false,
			contentType: "application/json; charset=utf-8",
			data: JSON.stringify(submittedData),
			dataType: "json",
			success: function(data) {
				responseData = data;
			},
			error: function(data) {
				responseData = data;
			},
			complete: function() {
				// console.log(responseData);

				_this.formNode.querySelector('.store-edit__form__response-message').innerHTML = responseData.d.HTML;
				_this.formNode.querySelector('.store-edit__form__response-message').classList.add('got-message');

				submitButton.classList.remove('disabled');
			}
		});
	}
}
